import { React, useState, useEffect, useImperativeHandle, forwardRef,useRef} from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  IconButton, Stack, TextField
} from "@mui/material";
import { saveAs } from "file-saver";
import Popover from "@mui/material/Popover";
import MenuItem from '@mui/material/MenuItem';
import { Calendar } from "react-multi-date-picker";
// import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Loading } from "../Loading";
// import { DataGrid, GridCellEditStopReasons } from '@mui/x-data-grid';
import "../pages/CheckIn.css";
import { apiMain } from "../../App";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import DatePicker from 'react-multi-date-picker';
// import { IconCalender } from '../images/IconCalender';
import * as XLSX from 'xlsx';
import OutlinedInput from '@mui/material/OutlinedInput';
// import gregorian from "react-date-object/calendars/gregorian";
import { useSnackbar } from "notistack";
import { useParams } from 'react-router-dom';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useReactToPrint } from "react-to-print";
import Chip from '@mui/material/Chip';
import moment from 'moment';
import { getData } from 'ajv/dist/compile/context';
import { Rows } from "lucide-react";
const RoomFee=forwardRef((props,ref)=> {
  const [loading, setLoading] = useState(false);
  // const [age, setAge] = useState('');
  const [updateCount, setUpdateCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [activeRowId, setActiveRowId] = useState(null);
  const gridRef = useRef();
  useEffect(() => {
    setAddflag(props.permission[3].Per_Add)
    setEditFlag(props.permission[3].Per_Edit)
    setDelFlag(props.permission[3].Per_Del)
    getRoom();
    getRoomType();
    getPresentType();
    getArzType();
    // getDataView();
   // setFrom_Date( new Date('2025-10-01'));
    setFrom_Date( moment('2025-01-01'));
 
    setTo_Date(moment(new Date))
  }, []);
  useEffect(() => {
    if (updateCount !== 0) {
      getDataView();
    }
  }, [updateCount])
  const [filter,setFilter]=useState(false)
  const [From_Date, setFrom_Date] = useState(new Date());
  const [To_Date, setTo_Date] = useState();

  const [Mydate, setMydate] = useState(new Date())
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  useImperativeHandle(ref, () => ({
    temp: downloadTemplate ,
    upload:handleFileUpload,
    filter:handelfilter,
    filteroff:handelfilteroff,
    pdf:exportToPDF,
    excel:exportToExcel,
    // print:handlePrint,
  }));
  // const handlePrint = useReactToPrint({
  //   content: () => gridRef.current,
  //   documentTitle: "Room Price",
  // });
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, `RoomPrice_${new Date().toISOString()}.xlsx`);
  };
  const exportToPDF = () => {
    console.log(rows)
    if (!rows || rows.length === 0) {
      enqueueSnackbar("No data to export", { variant: "warning" });
      return;
    }

    const doc = new jsPDF("p", "pt", "a4");
    doc.setFontSize(16);
    doc.text("Room Price", 40, 30);
    doc.setFontSize(10);
    doc.text(
      `From: ${From_Date.format("YYYY-MM-DD")}  To: ${To_Date.format(
        "YYYY-MM-DD"
      )}`,
      40,
      45
    );

    const head = [["RFee_AzDate", "RFee_TaDate", "Prese_Name", "Arze_Name", "DBL", "DBLSNG","DBLSNGSNG","TWN"]];
    const body = rows.map((d) => [
      d.RFee_AzDate || "",
      // d.Pass_LName || "",
      d.RFee_TaDate || "",
      d.Prese_Name || "",
      d.Arze_Name || "",
      d.DBL || "",
      d.DBLSNG || "",
      d.DBLSNGSNG || "",
      d.TWN || "",
    ]);

    autoTable(doc, {
      head,
      body,
      startY: 60,
      theme: "striped",
      headStyles: { fillColor: [22, 160, 133], textColor: 255 },
      styles: { fontSize: 9, cellPadding: 3 },
    });

    doc.save(`RoomPrice_${new Date().toISOString()}.pdf`);
  };

  const handelfilter = () => {
    //const newValue = !filter;
    setFilter(true);
  
  };
  const handelfilteroff = () => {
   // const newValue = !filter;
    setFilter(false);
  
       getRoom();
  
  };
  const handleFileUpload = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx, .xls";
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
  
      const reader = new FileReader();
      reader.onload = (ev) => {
        const data = new Uint8Array(ev.target.result);
        const workbook = XLSX.read(data, { type: "array", cellDates: true, dateNF: "yyyy-mm-dd" });
  
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
  
        // 🟢 ستون‌های اصلی
        const headers = [
          "RFee_AzDate",
          "RFee_TaDate",
          "Prese_Id",
          "Arze_Id",
          "DBL",
          "DBLSNG",
          "DBLSNGSNG",
          "TWN",
        ];
  
        // 🟢 فقط از ردیف 3 به بعد بخوان و header را مشخص کن
        let jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: headers,
          range: 2, // صفر مبنا → ردیف سوم
          defval: "",
        });
  
        // 🟢 حذف ردیف‌هایی که تمام ستون‌های اصلی خالی هستند
        jsonData = jsonData.filter((row) =>
          headers.some((h) => row[h] !== "" && row[h] !== null)
        );
  
        // 🟢 نرمال‌سازی تاریخ‌ها
        const normalizeDate = (value) => {
          if (!value) return "";
          if (typeof value === "number") {
            const parsed = XLSX.SSF.parse_date_code(value);
            if (parsed) {
              const y = parsed.y;
              const m = String(parsed.m).padStart(2, "0");
              const d = String(parsed.d).padStart(2, "0");
              return `${y}-${m}-${d}`;
            }
          }
          if (value instanceof Date) return value.toISOString().split("T")[0];
          if (typeof value === "string" && value.includes("/")) {
            const [m, d, y] = value.split("/");
            const date = new Date(`${y}-${m.padStart(2,"0")}-${d.padStart(2,"0")}`);
            if (!isNaN(date)) return date.toISOString().split("T")[0];
          }
          if (typeof value === "string" && value.includes("-")) return value;
          return value;
        };
  
        jsonData.forEach((row) => {
          row.RFee_AzDate = normalizeDate(row.RFee_AzDate);
          row.RFee_TaDate = normalizeDate(row.RFee_TaDate);
        });
  
    //    console.log("📅 داده‌های نهایی:", jsonData);
        jsonData.map( async (sel) => {
            // console.log('RFee_AzDate',sel.RFee_AzDate);
            // console.log('RFee_TaDate',sel.RFee_TaDate);
            // console.log('Prese_Id',sel.Prese_Id);
            // console.log('arze_id',sel.Arze_Id);
            // console.log('DBL',sel.DBL);
            // console.log('DBLSNG',sel.DBLSNG);
            // console.log('DBLSNGSNG',sel.DBLSNGSNG);
            // console.log('TWN',sel.TWN);
            let response;
            let formdataroomfee = new FormData();
            formdataroomfee.append("RFee_AzDate", sel.RFee_AzDate);
            formdataroomfee.append("RFee_TaDate", sel.RFee_TaDate);
            formdataroomfee.append("Prese_Id", sel.Prese_Id); // احتمالاً sel نه se
            formdataroomfee.append("Arze_Id", sel.Arze_Id);
            formdataroomfee.append("DBL", sel.DBL);
            formdataroomfee.append("DBLSNG", sel.DBLSNG);
            formdataroomfee.append("DBLSNGSNG", sel.DBLSNGSNG);
            formdataroomfee.append("TWN", sel.TWN);
            formdataroomfee.append("Roomfee_Id", 0);
            response = await PostDataPromise(apiMain + "/api/v1/roomfee/insert", formdataroomfee, false);
            let parsed = JSON.parse(response); // نتیجه‌ی fetch یا GetDataPromise
            if (parsed.status === "error") {
          // مدیریت خطا
              enqueueSnackbar(parsed.data?.message || "خطا در انجام عملیات", { variant: "error" });
              setDialogError(parsed.data?.message || {});
            }

         });
        // ارسال jsonData به API یا ذخیره‌سازی
      };
  
      reader.readAsArrayBuffer(file);
    };
  
    input.click();
  };
  
  const changePeres_Id = (event) => {
    setPrese_Id(event.target.value);

  };
  
  


 const downloadTemplate = async () => {
  // گرفتن داده‌ها از API
  let res = await GetDataPromise(`${apiMain}/api/v1/arzetype`, true);
  let arzeData = JSON.parse(res);

  let res1 = await GetDataPromise(`${apiMain}/api/v1/presents`, true);
  let preseData = JSON.parse(res1);

  preseData = preseData.data;
  arzeData = arzeData.data;

  // 🟢 ایجاد شیت و پیام راهنما
  const ws = XLSX.utils.json_to_sheet([]);
  XLSX.utils.sheet_add_aoa(
    ws,
    [
      [
        "⚠️ لطفاً تاریخ‌ها را به صورت متن و با فرمت yyyy-mm-dd وارد کنید (مثال: 2025-01-01).",
      ],
    ],
    { origin: "A1" }
  );

  // 🟢 ستون‌های اصلی (ردیف دوم)
  const columns = [
    "RFee_AzDate",
    "RFee_TaDate",
    "Prese_Id",
    "Arze_Id",
    "DBL",
    "DBLSNG",
    "DBLSNGSNG",
    "TWN",
  ];
  XLSX.utils.sheet_add_aoa(ws, [columns], { origin: "A2" });

  // 🟢 جدول Prese در ستون J
  const preseTable = [["Prese_Id", "Prese_Name"]];
  preseData.forEach((p) => preseTable.push([p.Prese_Id, p.Prese_Name]));
  XLSX.utils.sheet_add_aoa(ws, preseTable, { origin: "J1" });

  // 🟢 جدول Arze در ستون M
  const arzeTable = [["Arze_Id", "Arze_Name"]];
  arzeData.forEach((a) => arzeTable.push([a.Arze_Id, a.Arze_Name]));
  XLSX.utils.sheet_add_aoa(ws, arzeTable, { origin: "M1" });

  // 🟢 تنظیم فرمت Text برای ستون‌های تاریخ (A و B)
  const textRows = 500;
  for (let r = 2; r < textRows + 2; r++) {
    const addrA = XLSX.utils.encode_cell({ r, c: 0 });
    const addrB = XLSX.utils.encode_cell({ r, c: 1 });

    if (!ws[addrA]) ws[addrA] = { t: "s", v: "" };
    ws[addrA].t = "s";
    ws[addrA].z = "@";

    if (!ws[addrB]) ws[addrB] = { t: "s", v: "" };
    ws[addrB].t = "s";
    ws[addrB].z = "@";
  }

  // 🟢 مرج کردن ردیف اول (برای نمایش کامل پیام)
  ws["!merges"] = [
    {
      s: { r: 0, c: 0 }, // شروع از A1
      e: { r: 0, c: 7 }, // پایان در ستون H1 (می‌تونی تغییر بدی)
    },
  ];

  // 🟢 تنظیم محدوده شیت به صورت پویا
  const range = XLSX.utils.decode_range(ws["!ref"] || "A1");
  const lastCol = XLSX.utils.decode_col("M"); // ستون M = 12
  range.e.c = Math.max(range.e.c, lastCol);
  range.e.r = Math.max(range.e.r, textRows + 3);
  ws["!ref"] = XLSX.utils.encode_range(range);

  // ساخت فایل و دانلود
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Template");
  XLSX.writeFile(wb, "template.xlsx");
};

  
  
  
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [editMode, setEditMode] = useState(false); // حالت ویرایش
  const [Roomdata, setRoomeData] = useState([]);
  const [addoredit ,setAddOrEdit]=useState(false);
  const [data, setData] = useState({});
  // const params = useParams()
  // const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogError, setDialogError] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  // const [arzetype, setarzetype] = useState();
  // const [RFee_Fee, setRFee_Fee] = useState([]);
  const [Addflag,setAddflag]=useState(true);
  const [EditFlag,setEditFlag]=useState(false);
  const [DelFlag,setDelFlag]=useState(false);
  const [NewFlag,setNewFlag]=useState(true);
  const [rows, setRows] = useState(props.data || []);
  // const [Room_No, setRoom_No] = useState(0);
  // const [Rtype_Id, setRtype_Id] = useState(0);
  const [Prese_Id, setPrese_Id] = useState(0);
  const [RFee_AzDate, setRFee_AzDate] = useState("");
  const [RFee_TaDate, setRFee_TaDate] = useState("");
  const [Arze_Id, setArze_Id] = useState(0);
  const [Roomfee_Id, setRoomfee_Id] = useState();
  // const listItems = [];
  // const changeRoomNo = (event) => {
  //   setRoom_No(event.target.value);
  // };
  // const changeRFee_AzDate = (event) => {
  //   //  if (event.length==10)
  //   setRFee_AzDate(event.year + '-' + event.month + '-' + event.day);

  // };
  // const changeRFee = (event) => {

  //   let id = 0

  //   id = event.target.id

  //   if (parseInt(id) > RFee_Fee.length) {

  //     let myid = parseInt(id)
  //     RFee_Fee.push({ id: myid });
  //   }

  //   setRFee_Fee(RFee_Fee.map(com =>
  //     parseInt(id) === com.id ? { ...com, fee: event.target.value } : com
  //     // com.id === event.target.id ? { ...com, fname: event.target.value } : com
  //   ));

  // };
  const updateRow = (id, field, value) => {
    // console.log('id=',id)
    // console.log('field=',field)
    console.log('value=',value)
  
    if (field ==='RFee_AzDate')
   { var dat =value
    var mon=Number(dat.getMonth() )+ 1 
      let indate = dat.getFullYear() + '-' + mon+ '-' + dat.getDate();
      setRows(prev =>
        prev.map(r => (r.id === id ? { ...r, [field]: indate } : r))
      );
   }
   else
   if (field ==='RFee_TaDate')
   { var dat1 =value
    var mon1=Number(dat1.getMonth() )+ 1 
      let indate = dat1.getFullYear() + '-' + mon1+ '-' + dat1.getDate();
      setRows(prev =>
        prev.map(r => (r.id === id ? { ...r, [field]: indate } : r))
      );
   }
   else

    setRows(prev =>
      prev.map(r => (r.id === id ? { ...r, [field]: value } : r))

    );
  };
  // const changeRFee_TaDate = (event) => {
  //   // console.log(event.year + '-' + event.month + '-'+ event.day)
  //   // if (RFee_TaDate.length==10)
  //   setRFee_TaDate(event.year + '-' + event.month + '-' + event.day);
  // };
  // const changeRtype_Id = (event) => {
  //   localStorage.setItem('Rtype_Id', event.row.id)
  //   setRtype_Id(event.row.id)

  //   // setRtype_Id(event.target.value);
  // };
  // const chageRtype_Fee = (updatedRow, originalRow) => {
  //   const newRows = [...RoomTypedata];
  //   const idx = newRows.findIndex((x) => x.id === originalRow.id);
  //   newRows[idx] = updatedRow;
  //   setRoomTypeData(newRows);
  //   return updatedRow;
  // };
  // const changeRoom_No = (event) => {
  //   // setRoom_No(event.target.value);
  //   const {
  //     target: { value },
  //   } = event;
  //   setRoom_No(
  //     // On autofill we get a stringified value.
  //     typeof value === 'string' ? value.split(',') : value,
  //   );
  //   getDataView(event.target.value);
  // };
  const sendDelete = async (e) => {
    let formdata = new FormData();
  //  let uparams = new URLSearchParams();
    formdata.append("Roomfee_Id", Roomfee_Id);
  // let errors = {};
//     formdata.append("id", Id);

   let response;
    if(Roomfee_Id > 0){
      response = await PostDataPromise(apiMain + "/api/v1/roomfee_detail/delete", formdata);

         response = await PostDataPromise(apiMain + "/api/v1/roomfee/delete", formdata);
//        //  let parsed = JSON.parse(response);

     
    } 
       //  getData();  
//     setDialogLoading(false);
//     let parsed = JSON.parse(response);
//     if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
//         // okay
//         enqueueSnackbar(Messages.success, { variant: 'success' });

//         // props.save()
//     } else {
//         if(parsed.data && typeof parsed.data.message === "string"){
//             enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
//         }
//         setDialogError((parsed.data) ? parsed.data.message : {})
//     }
//  //   setUpdateCount((prev) => prev + 1)
//     getData(Cust_id);
    // cleardata()
    // AddOrEditCust();
  }
  
  // فعال کردن حالت ویرایش روی ردیف انتخاب شده
  const handleEdit = () => {
    if (selectedRowId){
       setEditMode(true);
       setActiveRowId(false);
       setAddOrEdit(false);
    }
  };

  // حذف ردیف
  const handleDelete = () => {
    if (!selectedRowId) return;
    sendDelete(selectedRowId);
    setRows(rows.filter(r => r.id !== selectedRowId));
    setSelectedRowId(null);
    setEditMode(false);
  };

  // ذخیره (نمونه)
  const handleSave = async (e) => {
    if (!selectedRowId)       return;
     let response;
   if (addoredit)
    {
 
          let y=rows.filter(r => r.id === selectedRowId)
                setRFee_AzDate(y[0].RFee_AzDate)
                setRFee_TaDate(y[0].RFee_TaDate)
                setPrese_Id(y[0].Prese_Id)
                setArze_Id(y[0].Arze_Id)
                setPrese_Id(0);
            // //   sendAdd(y);

            let uparams = new URLSearchParams();
            e.preventDefault();

            // let formdata = new FormData();
            uparams.append("From_Date", y[0].RFee_AzDate);
            uparams.append("To_Date", y[0].RFee_TaDate);
            uparams.append("Prese_Id", y[0].Prese_Id); // احتمالاً sel نه se
            uparams.append("Arze_Id", y[0].Arze_Id);

            let res = await GetDataPromise(`${apiMain}/api/v1/roomfee/checkexistfeedate?${uparams}`, true);
            let parsed1 = JSON.parse(res);
                if ((parsed1.status && parsed1.status !== "error") || parsed1.status === "success") {
              alert('This date has already been used.');
              return;
                    } 
              else {
              let formdataroomfee = new FormData();
              formdataroomfee.append("RFee_AzDate", y[0].RFee_AzDate);
              formdataroomfee.append("RFee_TaDate", y[0].RFee_TaDate);
              formdataroomfee.append("Prese_Id", y[0].Prese_Id); // احتمالاً sel نه se
              formdataroomfee.append("Arze_Id", y[0].Arze_Id);
              formdataroomfee.append("DBL", y[0].DBL);
              formdataroomfee.append("DBLSNG", y[0].DBLSNG);
              formdataroomfee.append("DBLSNGSNG", y[0].DBLSNGSNG);
              formdataroomfee.append("TWN", y[0].TWN);
              formdataroomfee.append("Roomfee_Id", 0);
              response = await PostDataPromise(apiMain + "/api/v1/roomfee/insert", formdataroomfee, false);
              let parsed = JSON.parse(response); // نتیجه‌ی fetch یا GetDataPromise
              if (parsed.status === "error") {
              
                  // مدیریت خطا
                enqueueSnackbar(parsed.data?.message || "خطا در انجام عملیات", { variant: "error" });
                setDialogError(parsed.data?.message || {});
              }}

  }
  // update
    else{
      let y=rows.filter(r => r.id === selectedRowId)
      if (y[0].Roomfee_Id> 0) {
        let uparams = new URLSearchParams();
        e.preventDefault();

        // let formdata = new FormData();
        uparams.append("From_Date", y[0].RFee_AzDate);
        uparams.append("To_Date", y[0].RFee_TaDate);
        uparams.append("Prese_Id", y[0].Prese_Id); // احتمالاً sel نه se
        uparams.append("Arze_Id", y[0].Arze_Id);

        let res = await GetDataPromise(`${apiMain}/api/v1/roomfee/checkexistfeedate?${uparams}`, true);
        let parsed1 = JSON.parse(res);
            if ((parsed1.status && parsed1.status !== "error") || parsed1.status === "success") {
          alert('This date has already been used.');
          return;
                } 
          else {
          //  console.log('RFee_AzDate', y[0].RFee_AzDate)
          //   console.log('RFee_TaDate',y[0].RFee_TaDate)
          //   console.log('Prese_Id',y[0].Prese_Id)
          //   console.log('Arze_Id',y[0].Arze_Id)
          //   console.log('DBL',y[0].DBL)
          //   console.log('DBL+SNG',y[0].DBLSNG)
          //   console.log('DBL+SNG+SNG',y[0].DBLSNGSNG)
          //   console.log('TWN',y[0].TWN)
            let formdataroomfee = new FormData();
            formdataroomfee.append("RFee_AzDate", y[0].RFee_AzDate);
            formdataroomfee.append("RFee_TaDate", y[0].RFee_TaDate);
            formdataroomfee.append("Prese_Id", y[0].Prese_Id); // احتمالاً sel نه se
            formdataroomfee.append("Arze_Id", y[0].Arze_Id);
            formdataroomfee.append("DBL", y[0].DBL);
            formdataroomfee.append("DBLSNG", y[0].DBLSNG);
            formdataroomfee.append("DBLSNGSNG", y[0].DBLSNGSNG);
            formdataroomfee.append("TWN", y[0].TWN);
            formdataroomfee.append("Roomfee_Id", y[0].Roomfee_Id);
        response = await PostDataPromise(apiMain + "/api/v1/roomfee/update", formdataroomfee,true);
          let parsed = JSON.parse(response);
          if (parsed.status === "error") {
              
            // مدیریت خطا
          enqueueSnackbar(parsed.data?.message || "خطا در انجام عملیات", { variant: "error" });
          setDialogError(parsed.data?.message || {});
        }}
   
    }}
 //   console.log("Saved rows:", rows);
    setEditMode(false);
    alert("Saved successfully!");
  };

  // باز کردن Popover تقویم
  const openCalendar = (event, rowId) => {
    setAnchorEl(event.currentTarget);
      setActiveRowId(rowId);
  };
  const openCalendar2 = (event, rowId) => {
    setAnchorEl2(event.currentTarget);
      setActiveRowId(rowId);
  };

  // const cleardata=()=>{
  //   // setId(0)
  //   setRFee_TaDate('');
  //   setRFee_AzDate('');
  //   setArze_Id(0);
  //   setSelected([]);
  //   // setCust_d_mab(0);
  
  //   setEditFlag(false);
  //   setDelFlag(false);
  //   setAddflag(true);
  //  // sumdata();
  // }
  // const changePrese_Id = (event) => {

  //   setPrese_Id(event.target.value);
  // };
//   const changeFrom_Date=(event)=>{
// //    var mon=Number(event.getMonth() )+ 1 
// //    let indate = event.getFullYear() + '-' + mon+ '-' + event.getDate();
//     setFrom_Date(event)
//   }
  // const changeArze_Id = (event) => {
  //   setArze_Id(event.target.value)


  // };

  const [RoomTypedata, setRoomTypeData] = useState([]);
  const [PresentTypeData, setPresentTypeData] = useState([{label:'' , width:160} ,{value:'' ,width:300}]);
  const [ArzeTypedata, setArzeTypeData] = useState([]);
  const [selected, setSelected] = useState([]);
  // const onChangeDate = (e) => {
  //   let y = e.year;
  //   let m = e.month;
  //   let d = e.day;
  //   props.ClearZan();
  //   props.GetData(y, m, d);
  //   setMydate(e)

  // }
  // const columnsFee = [

  //   { field: 'Roomfee_Id', headerName: 'ID', width: 50, editable: false },

  //   { field: 'RFee_AzDate', headerName: 'From Date', width: 90, editable: true, type: 'Date', filterable: true,},
  //   {
  //     field: 'RFee_TaDate',
  //     headerName: 'To Date',
  //     width: 90,
  //     type: 'Date',
  //     editable: true,
  //     filterable: true,
  //   },
  //   {
  //     field: 'Prese_Name',
  //     headerName: 'Type',
  //     width: 90,
  //     type: 'Text',
  //     editable: true,
  //     filterable: true,
  //   },
  //   {
  //     field: 'Arze_Name',
  //     headerName: 'Currency',
  //     width: 90,
  //     type: 'Text',
  //     editable: true,
  //     filterable: true,
  //   },
  //   {
  //     field: 'Prese_Id',
  //     headerName: 'Prese_Id',
  //     width: 0,
  //     type: 'Text',
  //     editable: true,
  //     filterable: true,
  //     hide: true
  //   },
  //   {
  //     field: 'Arze_Id',
  //     headerName: 'Arze_Id',
  //     width: 0,
  //     type: 'Text',
  //     editable: true,
  //     filterable: true,
  //     hide: true
  //   },
  // ];

//   const columns = [



//     { field: 'id', headerName: 'ID', width: 50, editable: false },

//     { field: 'Rtype_Name', headerName: 'Room Type', width: 190, editable: true },
//     {
//       field: 'Rtype_Fee',
//       headerName: 'Fee',
//       width: 150,
//       type: 'text',
//       editable: true,
//       filterable: true,
   
//     },
//  ];
  const getRoom = async () => {
    let res = await GetDataPromise(`${apiMain}/api/v1/roomfee/selectall`, true);
    let parsed = JSON.parse(res);
 
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
     let newData = parsed.data;
      setRoomeData(newData)
//console.log(newData)
      //    const  newDetailData=await getRoomFee()
     setRows(newData);
  
    }
  }
  const filterview = async () => {
    let uparams = new URLSearchParams();
      // let formdata = new FormData();
    uparams.append("RFee_AzDate", From_Date);
    uparams.append("RFee_TaDate", To_Date);
    uparams.append("Prese_Id", Prese_Id); // احتمالاً sel نه se-

    // console.log("Prese_Id", uparams.get('RFee_AzDate')); // احتمالاً sel نه se
    // console.log("Prese_Id", uparams.get('RFee_TaDate')); // احتمالاً sel نه se
    let res = await GetDataPromise(`${apiMain}/api/v1/roomfee/selectfilter?${uparams}`, true);

      let parsed = JSON.parse(res);
 
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
     let newData = parsed.data;
      
   //   setRoomeData(newData)
      //    const  newDetailData=await getRoomFee()
     setRows(newData);
  
    }
  }
  const getDataView = async (r_no) => {
    // let uparams = new URLSearchParams();

    // uparams.append("Room_No", r_no);
    let res = await GetDataPromise(`${apiMain}/api/v1/presents`, true);

    // let res = await GetDataPromise(`${apiMain}/api/v1/reservation`, force);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setData(newData)
      // setData(prev => {
      //     return {
      //         ...prev,
      //         attr: newData
      //     }
      // })
    }
  }
  const handleAdd = () => {
    const newId = crypto.randomUUID();
    const newRow = { id: newId, RFee_AzDate: null,RFee_TaDate:null, Prese_Id : 0, Arze_Id: 0 ,DBL:0,DBLSNG:0,DBLSNGSNG:0,TWN:0};

    setRows([newRow, ...rows]);
    setSelectedRowId(newId);
    setEditMode(true);
    setAddOrEdit(true)
  };
  // const handleRowClick = (params) => {
  //   localStorage.setItem('Roomfee_Id', params.row.Roomfee_Id)
  //   setRoomfee_Id(params.row.Roomfee_Id)
  //   setRFee_AzDate(params.row.RFee_AzDate)
  //   setRFee_TaDate(params.row.RFee_TaDate)
  //   let Prese_Id=params.row.Prese_Id
  //   let arze_id=params.row.Arze_Id
  //   // setEditFlag(true)
  //   getRoomFee(params.row.Roomfee_Id)
  //   setSelected([])
  //   PresentTypeData.map(sel => {

  //     if (sel.Prese_Id === Prese_Id){
  //     // console.log(sel)
  //      setSelected((prev) => {
  //        let temp = [...prev];
  //        let findIndex = temp.findIndex((v) => v.Prese_Id === sel.Prese_Id);
  //        if(findIndex !== -1){
  //          temp.splice(findIndex, 1);
  //        } else {
  //          temp.push(sel);
  //        }
  //        // console.log(temp)
  //        return temp;
  //      })
  //     }
      
   
  //     getShowData(params.row.Roomfee_Id,Prese_Id,arze_id)
  //   })
  // }
  const getArzType = async () => {
    let res = await GetDataPromise(`${apiMain}/api/v1/arzetype`, false);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setArzeTypeData(newData)


    }
  }
  const getRoomFee = async (Roomfee_IdTemp = Roomfee_Id) => {
    setLoading(true);
    console.log('Loading ...');
    <Loading small={true}/> // اگر این قسمت هم به طور صحیح کار نمی‌کند، بررسی کنید که درست رندر می‌شود.
  
    try {
      let res = await GetDataPromise(`${apiMain}/api/v1/roomfee_detail/selectfee?Roomfee_Id=${Roomfee_IdTemp}`, true);
    //  console.log('پاسخ API:', res);  // اینجا پاسخ دریافتی API را بررسی کنید
  
      let parsed = JSON.parse(res);
  
      // بررسی وضعیت پاسخ API
      if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
        let newData = parsed.data;
       console.log('داده‌های جدید:', newData);  // چک کردن داده‌ها
        return newData; // داده‌ها را به تابع فراخوانی برمی‌گردانیم
      } else {
        console.error('خطا در پاسخ API:', parsed);  // در صورت وجود خطا در پاسخ
        return [];  // بازگشت آرایه خالی در صورت خطا
      }
    } catch (error) {
      console.error('خطا در دریافت داده‌ها:', error);
      return [];  // در صورت بروز خطا در درخواست
    } finally {
      setLoading(false);
    }
  };
  
  const getPresentType = async () => {
    let res = await GetDataPromise(`${apiMain}/api/v1/presents`, false);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setPresentTypeData(newData)
    }

  }
  const getRoomType = async () => {
    let res = await GetDataPromise(`${apiMain}/api/v1/roomtype/select`, false);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setRoomTypeData(newData)
     // console.log('roomtype')
    //  console.log(newData)
    }
  }
  async function getFee(formdata) {
    // ✅ Successful assignment - no error
    const rez = await PostDataPromise(apiMain + "/api/v1/roomfee_detail/insert", formdata, true);

    return rez;
  }
  // async function getdeleteroomFee(formdata) {
  //   // ✅ Successful assignment - no error
  //   const rez = await PostDataPromise(apiMain + "/api/v1/roomfee_detail/deletepreserv", formdata, true);

  //   return rez;
  // }
//   const sendAdd = async (e) => {
//     let response;
//     let fsave=false;
//     if (selected.length === 0) {
//       alert('Please select any type')
//     }
//     else {
//       selected.map(async sel => {
//         let uparams = new URLSearchParams();
//         e.preventDefault();
      
//         let formdata = new FormData();
//         uparams.append("From_Date", RFee_AzDate);
//         uparams.append("To_Date", RFee_TaDate);
//         uparams.append("Prese_Id", sel.Prese_Id); // احتمالاً sel نه se
//         uparams.append("Arze_Id", Arze_Id);
//         uparams.append("Roomfee_Id", 0);
//         let res = await GetDataPromise(`${apiMain}/api/v1/roomfee/checkexistfeedate?${uparams}`, true);
//         let parsed1 = JSON.parse(res);
//             if ((parsed1.status && parsed1.status !== "error") || parsed1.status === "success") {
//           alert('This date has already been used.');
//           return;
//         } else {
//           let formdataroomfee = new FormData();
      
//           formdataroomfee.append("RFee_AzDate", RFee_AzDate)
//           formdataroomfee.append("RFee_TaDate", RFee_TaDate)
//           formdataroomfee.append("Prese_Id", sel.Prese_Id); // احتمالاً sel نه se
//           formdataroomfee.append("Arze_Id", Arze_Id);
//           response = await PostDataPromise(apiMain + "/api/v1/roomfee/insert", formdataroomfee, false);
//           let parsed = JSON.parse(response); // نتیجه‌ی fetch یا GetDataPromise
//           if (parsed.status === "success") {
//             // مقدار مورد نظرتو بگیر
//             let newId = parsed.data.Roomfee_Id;
          
     
//           formdata.append("Roomfee_Id", newId);
//           formdata.append("Prese_Id", sel.value)
//           RoomTypedata.forEach(room => {
//             formdata.append("Rtype_Id", room.Rtype_Id)
//             formdata.append("RFee_Fee", room.Rtype_Fee)
    
//             response = getFee(formdata)

//    fsave=true;
    
//           })
          
//           } else {
//             // مدیریت خطا
//             enqueueSnackbar(parsed.data?.message || "خطا در انجام عملیات", { variant: "error" });
//             setDialogError(parsed.data?.message || {});
//           }
          
//         }
        
//       });
      

// }
// if (fsave)
// {
//  alert('Data saved. ')
// }
// getData()
// // cleardata();
// }
//   const sendUpdate = async (e) => {
//     let response;
//     if (selected.length === 0) {
//       alert('Please select any type')
//     }
//     else {
//       selected.map(async sel => {
//         let uparams = new URLSearchParams();
//        setLoading(true)
//       <Loading small={true}/>
//       e.preventDefault()
      
//         let formdata = new FormData();
//         uparams.append("From_Date", RFee_AzDate);
//         uparams.append("To_Date", RFee_TaDate);
//         uparams.append("Prese_Id", sel.Prese_Id); // احتمالاً sel نه se
//         uparams.append("Arze_Id", Arze_Id);
//          uparams.append("Roomfee_Id", Roomfee_Id);
//         let res = await GetDataPromise(`${apiMain}/api/v1/roomfee/checkexistfeedate?${uparams}`, true);
//         let parsed1 = JSON.parse(res);
//             if ((parsed1.status && parsed1.status !== "error") || parsed1.status === "success") {
//           alert('This date has already been used.');
//           return;
//         } 
    

//       if (Roomfee_Id > 0) {
    
//             response = await PostDataPromise(apiMain + "/api/v1/roomfee/update", uparams,true);
//         let parsed = JSON.parse(response);
//         setRoomfee_Id(parsed.data[0]);
//         formdata.append("Arze_Id", Arze_Id)
//         formdata.append("Roomfee_Id", Roomfee_Id);
//         selected.map(sel => {
//              formdata.append("Prese_Id", sel.value);
//              response =getdeleteroomFee(formdata);
//         //     let parsed = JSON.parse(response);
     
//                  RoomTypedata.forEach(room => {
//                         formdata.append("Rtype_Id", room.Rtype_Id)
//                         formdata.append("RFee_Fee", room.Rtype_Fee)
//                         response = getFee(formdata)
//           })
//         })
//       }
//       })
//       }
           
  
//   setLoading(false)
//   alert('Data is Saved.')

// }

  
// function clearitemall() {
//   setRoomfee_Id(0);
//   localStorage.setItem('Roomfee_Id', 0)
//   setRoom_No(0);
//   setRtype_Id(0);
//   setPrese_Id(0);
//   setRFee_AzDate(new Date());
//   setRFee_TaDate(new Date());
//   setArze_Id(0);
//   setData({});
//   getRoomType();
//   setSelected([]);
//   // setRFee_Fee([{ id: 1, arze: 0, fee: 0 }])
//   // getRoomFee();
//   //setRFee_Fee (0);
//   //setRFee_Rate  (0);

// }
// function allitemupdate(Roomfee_Id,  rtype_id, Prese_Id,  arze_id) {

//   setRtype_Id(rtype_id);

//  // setPrese_Id(Prese_Id);
//   // setRFee_Fee([{ id:1, arze: 0, fee: 0  }])
//   getRoomFee(Roomfee_Id);
//   setEditFlag(true)
//   setSelected([])

//   PresentTypeData.map(sel => {

//    if (sel.Prese_Id === Prese_Id){
//    // console.log(sel)
//     setSelected((prev) => {
//       let temp = [...prev];
//       let findIndex = temp.findIndex((v) => v.Prese_Id === sel.Prese_Id);
//       if(findIndex !== -1){
//         temp.splice(findIndex, 1);
//       } else {
//         temp.push(sel);
//       }
//       // console.log(temp)
//       return temp;
//     })
//    }
   

//     getShowData(Roomfee_Id,Prese_Id,arze_id)
//  })


// }
const getShowData = async (Roomfee_Id,Prese_Id,arze_id) => {

  let uparams = new URLSearchParams();
// alert(Roomfee_Id)
// alert(Prese_Id)
// alert(arze_id)
  uparams.append("Roomfee_Id", Roomfee_Id);
  uparams.append("Prese_Id", Prese_Id);
  uparams.append("Arze_Id", arze_id);
   let res =await GetDataPromise(`${apiMain}/api/v1/roomfee_detail/selectRommfee?${uparams}`, false);
   let parsed = JSON.parse(res);

   if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
     let newData = parsed.data;
       setRoomTypeData(newData)
        
   }


}
// const paginationModel = { page: 0, pageSize: 5 };
return (
 <>
    {filter && (
          <div className="CheckIn" style={{display:'flex',float:'left',textAlign:'left',height:'30px', width:'820px',marginTop:'5px',marginLeft:'50px'}}>

                  <fieldset>
                  <form action="#" method="get">
                  <div style={{marginTop:'0px'}}>
                  <label style={{fontSize:'10px'}} for="checkoutdate">Login Date</label>
                  <DatePicker
                          value={From_Date}
                          onChange={setFrom_Date}
                          style={{ height: "20px" ,marginLeft:'10px',width:'90px'}}
                        />
                      <label  for="checkoutdate" style={{marginLeft:'10px',fontSize:'10px'}}>Logout Date</label>
                      <DatePicker
                          value={To_Date}
                          onChange={setTo_Date}
                          style={{ height: "20px" ,marginLeft:'10px',width:'90px'}}

                        />
                              <label  for="checkoutdate" style={{marginLeft:'10px',fontSize:'10px'}}>Type</label>
 
            <Select style={{ width: '180px', height: '20px', marginLeft: '30px', backgroundColor: "rgb(225, 225, 198)" }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                
                value={Prese_Id}
                onChange={changePeres_Id}
                input={<OutlinedInput label="Name" />}
                MenuProps={MenuProps}
              >
                <MenuItem value="0">
                  <em>All</em>
                </MenuItem>
                {PresentTypeData.map((dat) => (
                  <MenuItem key={dat.value} value={dat.value}>{dat.label}</MenuItem>
                ))}

              </Select>
                  <Chip label="Filter" onClick={()=>filterview()}
                   color="primary" disabled={!NewFlag}
                    sx={{width:80 ,cursor:'pointer',marginLeft:'10px'}} />

                  </div>
                  </form>
                  </fieldset>
</div>
)}
    <div style={{ display: "flex", gap: "10px",width:'920px' }}>
      {/* Toolbar عمودی */}
      <Stack spacing={1} direction="column">
        <IconButton color="primary" onClick={handleAdd}><AddIcon /></IconButton>
        <IconButton color="secondary" onClick={handleEdit} disabled={!selectedRowId}><EditIcon /></IconButton>
        <IconButton color="error" onClick={handleDelete} disabled={!selectedRowId}><DeleteIcon /></IconButton>
        <IconButton color="success" onClick={handleSave} disabled={!editMode}><SaveIcon /></IconButton>
      </Stack>

      {/* جدول */}
      <TableContainer component={Paper} sx={{ flex: 1,height:400,width:850 }}>

        <Table size="small" sx={{  tableLayout: 'fixed',  fontSize: '0.5rem',width:850 }}>
          <TableHead  style={{height:'10px'}}>
            <TableRow  sx={{minHeight:10,maxHeight:70,height:30}}> 
            <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' ,width:20, fontSize: '0.7rem',textAlign: 'center'}}>ID</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' ,width:50, fontSize: '0.7rem',textAlign: 'center'}}>From Date</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white',width:5 ,textAlign: 'center'}}></TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' ,width:40, fontSize: '0.7rem',textAlign: 'center'}}>To Date</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' ,width:5,textAlign: 'center'}}></TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' ,width:50, fontSize: '0.7rem',textAlign: 'center'}}>Type</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white' ,width:50, fontSize: '0.7rem',textAlign: 'center'}}>Currency</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white',width:40, fontSize: '0.7rem' ,textAlign: 'center'}}>DBL</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white',width:40, fontSize: '0.7rem' ,textAlign: 'center'}}>DBL+SNG</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white',width:40, fontSize: '0.7rem' ,textAlign: 'center'}}>DBL+SNG+SNG</TableCell>
              <TableCell sx={{ backgroundColor: '#1976d2', color: 'white',width:40, fontSize: '0.7rem' ,textAlign: 'center'}}>TWN</TableCell>

            </TableRow>
          </TableHead>

          <TableBody>

  {rows.map(row => (
          
    <TableRow
      key={row.id}
      selected={row.id === selectedRowId}
     onClick={() => setSelectedRowId(row.id)}
 // ارتفاع سطر
      sx={{minHeight:10,maxHeight:30,height:20}}> 
        
        <TableCell sx={{ padding: '2px 4px', height: 20, lineHeight: '20px', fontSize: '0.7rem' }}>
       {row.Roomfee_Id }
      </TableCell>
    <TableCell sx={{ padding: '2px 4px', height: 20, lineHeight: '20px', fontSize: '0.7rem' }}>

 {/* </TableCell>     <TableCell sx={{ padding: '1px 2px' ,width:100,fontSize: '0.7rem'}}> */}
      {/* {row.Resturant_Date ? row.Resturant_Date.toLocaleDateString("en-GB") : ""} */}
        {row.RFee_AzDate }
  
      </TableCell>
      <TableCell sx={{ padding: '2px 4px'}}>
        <IconButton
          color="primary"
          size="small"
          onClick={(e) => openCalendar(e, row.id)}
        >
          <CalendarMonthIcon fontSize="small" />

        </IconButton>
      </TableCell>
      <TableCell sx={{ padding: '1px 2px',width:100 ,fontSize: '0.7rem'}}>
      {/* {row.Resturant_Date ? row.Resturant_Date.toLocaleDateString("en-GB") : ""} */}
        {row.RFee_TaDate }
  
      </TableCell>
      <TableCell sx={{ padding: '2px 4px',fontSize: '0.7rem'}}>
        <IconButton
          color="primary"
          size="small"
          onClick={(e) => openCalendar2(e, row.id)}
        >
          <CalendarMonthIcon fontSize="small" />

        </IconButton>
      </TableCell>

      <TableCell sx={{ padding: '1px 2px',fontSize: '0.7rem' }}>
                    <Select 
                      sx={{ height: 20, minHeight: 20, fontSize: '0.7rem', '& .MuiSelect-select': { paddingTop: 0, paddingBottom: 0, height: 20 } }}

                  labelId="demo-multiple-name-label"
              // value={(RFee_Fee.filter(com => (i+1) === com.id).length ? RFee_Fee.filter(com => (i+1) === com.id)[0] : {}).arze}
              value={row.Prese_Id || ""}
              // onChange={changePrese_Id}
              onChange={(e) => updateRow(row.id, 'Prese_Id', e.target.value)} // آپدیت سطر
              input={<OutlinedInput label="Name" />}
              MenuProps={MenuProps}
            >
              
              <MenuItem value="">
                <em>None</em>
              </MenuItem>

              {PresentTypeData.map((dat) => (

                <MenuItem key={dat.Prese_Id} value={dat.Prese_Id}>{dat.Prese_Name}</MenuItem>
              ))}

            </Select>
      </TableCell>
      <TableCell sx={{ padding: '1px 2px',fontSize: '0.7rem' }}>
      {/* style={{ height: '30px',width:'100px',  backgroundColor: 'white' ,float:'right',fontSize:'12px'}} */}
      <Select 
        sx={{ height: 20, minHeight: 20, fontSize: '0.7rem', '& .MuiSelect-select': { paddingTop: 0, paddingBottom: 0, height: 20 } }}

              labelId="demo-multiple-name-label"
              // value={(RFee_Fee.filter(com => (i+1) === com.id).length ? RFee_Fee.filter(com => (i+1) === com.id)[0] : {}).arze}
              value={row.Arze_Id || ""}
              // onChange={changeArze_Id}
              onChange={(e) => updateRow(row.id, 'Arze_Id', e.target.value)}
              input={<OutlinedInput label="Name" />}
              MenuProps={MenuProps}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>

              {ArzeTypedata.map((dat) => (

                <MenuItem key={dat.Arze_Id} value={dat.Arze_Id.toString()}>{dat.Arze_Name}</MenuItem>
              ))}

            </Select>
            </TableCell>
            {/* {RoomTypedata.map((dat) => ( */}
    <TableCell  key={row.id} sx={{ padding: '4px 8px',fontSize: '0.7rem' }}>
        <TextField
         size="small"
        variant="standard"
        sx={{ '& .MuiInputBase-root': { height: 20, fontSize: '0.7rem', padding: '0 8px' } }}
                     // کاهش ارتفاع
          InputProps={{              // کاهش فونت و پدینگ داخلی
            style: { fontSize: '0.7rem', padding: '4px 8px' }
          }}
          type="text"
          value={row.DBL}
          onChange={(e) => updateRow(row.id, 'DBL', Number(e.target.value))}
              margin="dense"
          fullWidth
          disabled={!(editMode && selectedRowId === row.id)}
        />
      </TableCell>
      <TableCell  key={row.id} sx={{ padding: '4px 8px',fontSize: '0.7rem' }}>
        <TextField
         size="small"
        variant="standard"
        sx={{ '& .MuiInputBase-root': { height: 20, fontSize: '0.7rem', padding: '0 8px' } }}
                     // کاهش ارتفاع
          InputProps={{              // کاهش فونت و پدینگ داخلی
            style: { fontSize: '0.7rem', padding: '4px 8px' }
          }}
          type="text"
          value={row.DBLSNG}
          onChange={(e) => updateRow(row.id, 'DBLSNG', Number(e.target.value))}
          margin="dense"
          fullWidth
          disabled={!(editMode && selectedRowId === row.id)}
        />
      </TableCell>
      <TableCell  key={row.id} sx={{ padding: '4px 8px',fontSize: '0.7rem' }}>
        <TextField
         size="small"
        variant="standard"
        sx={{ '& .MuiInputBase-root': { height: 20, fontSize: '0.7rem', padding: '0 8px' } }}
                     // کاهش ارتفاع
          InputProps={{              // کاهش فونت و پدینگ داخلی
            style: { fontSize: '0.7rem', padding: '4px 8px' }
          }}
          type="text"
          value={row.DBLSNGSNG}
          onChange={(e) => updateRow(row.id, 'DBLSNGSNG', Number(e.target.value))}
            margin="dense"
          fullWidth
          disabled={!(editMode && selectedRowId === row.id)}
        />
      </TableCell>
      <TableCell  key={row.id} sx={{ padding: '4px 8px',fontSize: '0.7rem' }}>
        <TextField
         size="small"
        variant="standard"
        sx={{ '& .MuiInputBase-root': { height: 20, fontSize: '0.7rem', padding: '0 8px' } }}
                     // کاهش ارتفاع
          InputProps={{              // کاهش فونت و پدینگ داخلی
            style: { fontSize: '0.7rem', padding: '4px 8px' }
          }}
          type="text"
          value={row.TWN}
          onChange={(e) => updateRow(row.id, 'TWN', Number(e.target.value))}
          margin="dense"
          fullWidth
          disabled={!(editMode && selectedRowId === row.id)}
        />
      </TableCell>
    </TableRow>
  ))}
</TableBody>

        </Table>
      </TableContainer>

      {/* Popover تقویم */}
      <Popover
        open={Boolean(anchorEl) && activeRowId !== null}
        anchorEl={anchorEl}
        onClose={() => { setAnchorEl(null); setActiveRowId(null); }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: { p: 0, borderRadius: 2, overflow: "visible" } }}
      >
        <Calendar
          value={activeRowId ? rows.find(r => r.id === activeRowId)?.RFee_AzDate || null : null}
       //   calendar={gregorian}
          onChange={(date) => {
            if (!activeRowId) return;
            const jsDate = date?.toDate?.() || date;
            updateRow(activeRowId, "RFee_AzDate", jsDate);
            setAnchorEl(null);
                 setActiveRowId(null);
                 
          }}
        />
      </Popover>
      <Popover
        open={Boolean(anchorEl2) && activeRowId !== null}
        anchorEl={anchorEl2}
        onClose={() => { setAnchorEl2(null); setActiveRowId(null); }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: { p: 0, borderRadius: 2, overflow: "visible" } }}
      >
        <Calendar
          value={activeRowId ? rows.find(r => r.id === activeRowId)?.RFee_TaDate || null : null}
       //   calendar={gregorian}
          onChange={(date) => {
            if (!activeRowId) return;
            const jsDate2 = date?.toDate?.() || date;
            updateRow(activeRowId, "RFee_TaDate", jsDate2);
            setAnchorEl2(null);
                 setActiveRowId(null);
                 
          }}
        />
      </Popover>
    </div>

    </>
)


})
export default RoomFee